/* tslint:disable */
/* eslint-disable */
/**
 * Notification service API
 * Service for handling and managing notifications
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Just some response for any post requests there request does not matter
 * @export
 * @interface NotificationResponseDto
 */
export interface NotificationResponseDto {
    /**
     * User Id
     * @type {string}
     * @memberof NotificationResponseDto
     */
    userId?: string;
}

/**
 * Check if a given object implements the NotificationResponseDto interface.
 */
export function instanceOfNotificationResponseDto(value: object): boolean {
    return true;
}

export function NotificationResponseDtoFromJSON(json: any): NotificationResponseDto {
    return NotificationResponseDtoFromJSONTyped(json, false);
}

export function NotificationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function NotificationResponseDtoToJSON(value?: NotificationResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
    };
}

